<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <div class="top">
        <a-row type="flex" style="height: 100%;">
          <a-col flex="100px">
            <!-- <a-icon type="code" @click="$router.push('/auth/login')" style="position: fixed; font-size: 32px; margin: 8px;"/> -->
          </a-col>
          <a-col flex="auto">
            <h2 style="margin-top: 10px; text-align: center;" @click="ciallo">
              <audio ref="audio" :src="url"></audio>
              {{ $route.meta.title }}
            </h2>
          </a-col>
          <a-col flex="100px">
            <a-dropdown style="float: right; margin: 8px;" v-if="hideOptionList.indexOf($route.name) === -1">
              <a class="ant-dropdown-link" @click="e => e.preventDefault()" style="color: #555;">
                <a-icon type="project" style="font-size: 30px;"/> <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item key="1" @click="$message.warning('不，你没意见')">
                  <a target="_blank" rel="noopener noreferrer">意见反馈</a>
                </a-menu-item>
                <a-menu-divider />
                <a-menu-item key="3" @click="$router.push('/')">
                  退出
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-col>
        </a-row>
      </div>
      <div style="padding-top: 52px;">
        <router-view
          style="min-height: calc(100vh - 52px);"
          :style="{
            'padding': noPaddingList.indexOf($route.name) > -1 ? '0px': '20px',
            'background-color': bgcGrayList.indexOf($route.name) > -1 ? '#eee': '#fff'
          }"
          class="router"
        />
      </div>
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import audio from '@/assets/ciallo.mp3'
export default {
  data() {
    return {
      zhCN,
      url: audio,
      bgcGrayList: ['list', 'detail', 'managePage', 'contestantList', 'contestantDetail', 'contestantAdd', 'scoreRuleList', 'scoreRuleAdd', 'scoreRuleDetail', 'groupList', 'inviteList', 'judgeWhiteList', 'judgeWhiteListManage', 'detailConfig', 'contestantVoteDataDetail', 'judgeVotedData', 'contestantVoteData', 'dataAnalysisSelfDefine'],
      noPaddingList: ['judgeWhiteList', 'judgeContestantList', 'contestantVoteData', 'contestantVoteDataDetail', 'judgeVotedData'],
      hideOptionList: ['dataDisplay'],
    }
  },
  mounted() {
  },
  methods: {
    ciallo() {
      this.$message.info('Ciallo～ (∠・ω< )⌒★', 1)
      // this.$refs.audio.play()
    },
  },
}
</script>

<style lang="less" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

.top {
  width: 100%;
  height: 52px;
  border-bottom: 1px solid #cccccc;
  position: fixed;
  background-color: #fff;
  z-index: 999;
}

::v-deep .ant-drawer-body {
  padding: 0 !important;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.router {
  text-align: left;
}
</style>
